import { useNavigate } from "react-router-dom";
import { MdModeEditOutline } from "react-icons/md";
import { IoIosRemove } from "react-icons/io";

function FCRow(props) {
  const navigate = useNavigate();

  return (
    <div className="flex my-4 h-36">
      <p className="w-5/12 rounded-lg border-solid border border-slate-300 mx-2 text-center flex flex-col justify-center break-words">
        {props.title}
      </p>
      <p className="w-5/12 rounded-lg border-solid border border-slate-300 mx-2 text-center flex flex-col justify-center">
        {props.description}
      </p>
      <div className="w-1/12 m-auto flex justify-around md:flex-col md:justify-between md:my-10">
        <div
          className="cursor-pointer rounded-full bg-orange-200 flex justify-center pt-1 hover:bg-orange-300 md:mx-auto"
          style={{
            height: "1.8rem",
            width: "1.8rem",
            //   borderRadius: "50%",
            //   backgroundColor: "#bbb",
          }}
          onClick={() => {
            navigate(`/dashboard/set/${props.setName}/editcard/${props.id}`, {
              state: {
                title: props.title,
                description: props.description,
                id: props.id,
              },
            });
          }}
        >
          <MdModeEditOutline className="fill-white" />
        </div>
        <div
          className="cursor-pointer rounded-full bg-red-300 font-semibold flex justify-center pt-1.5 hover:bg-red-500 md:mx-auto"
          style={{
            height: "1.8rem",
            width: "1.8rem",
            //   borderRadius: "50%",
            //   backgroundColor: "#bbb",
          }}
          onClick={() => {
            navigate(`/dashboard/set/${props.setName}/deletecard/${props.id}`, {
              state: {
                nameCap: props.nameCap,
              },
            });
          }}
        >
          <IoIosRemove className="fill-white" />
        </div>
      </div>
    </div>
  );
}

export default FCRow;
